import React from 'react'
import Footer from '../Components/Footer/Footer'
import Navbar from '../Components/Navbar'
import Portfolio from '../Components/Portfolio/Portfolio'

const Project = () => {
    return (
        <div>
            <Navbar/>
            <Portfolio/>
            <Footer/>
        </div>
    )
}

export default Project
